import React, { useState } from "react";

function FilterButton({ onFilter, colourBlindMode }) {
    const [isOpen, setIsOpen] = useState(false);
    const getBackgroundColor = (colourBlindMode) => {
        switch (colourBlindMode) {
            case true:
                return "bg-[#FFF5EB]"
            default:
                return "bg-[#FFF6E0]";
        }
      };
    

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const dropdownOptions = [
        "Frontend",
        "Backend",
        "API",
        "Database",
        "Testing",
        "UI",
        "Framework",
        "UX",
        "None",
    ];

    return (
        <div className="relative">
            <button
                className={`${getBackgroundColor(colourBlindMode)} px-4 py-2 rounded-full  flex items-center sm:px-6 md:px-8 lg:px-10 xl:px-12 text-lg`}
                onClick={toggleDropdown}
            >
                Filter
                <i
                    className={`fas fa-filter ml-2 ${
                        isOpen ? "rotate-180" : ""
                    }`}
                ></i>
            </button>
            {isOpen && (
                <div className={`${getBackgroundColor(colourBlindMode)} absolute z-10 mt-2 py-2 w-40 rounded-lg shadow-lg`}>
                    {dropdownOptions.map((option, index) => (
                        <div
                            key={index}
                            className={`${getBackgroundColor(colourBlindMode)} px-4 py-2 hover:border-black hover:border-b cursor-pointer`}
                            onClick={() => onFilter(option)}
                        >
                            {option}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default FilterButton;
